"use client";

import { classed, clsx } from "@trydig/ui";
import type React from "react";
import type { ComponentProps } from "react";
import styles from "./Input.module.css";

export interface InputProps extends ComponentProps<"input"> {
	error?: string | boolean;
	success?: string | boolean;
	subText?: string;
	fullWidth?: boolean;
}

// export const Input = ({
// 	id: initialId,
// 	className,
// 	type = "text",
// 	error,
// 	success,
// 	subText,
// 	fullWidth,
// 	...props
// }: InputProps) => {
// 	const internalId = useId();
// 	const id = initialId ?? internalId;
// 	const ref = useRef<HTMLInputElement>(null!);

// 	return (
// 		<>
// 			<label htmlFor={id} className={clsx(styles.root, className)}>
// 				<div className={clsx(styles.input, error && styles.error, fullWidth && styles.fullWidth)}>
// 					<input ref={ref} type={type} id={id} {...props} />
// 				</div>
// 			</label>
// 			{subText && <span className={styles.text}>{subText}</span>}

// 			{((error && typeof error === "string") || (success && typeof success === "string")) && (
// 				<div
// 					className={clsx(
// 						styles.text,
// 						styles.statusText,
// 						error && styles.errorText,
// 						success && styles.successText,
// 					)}
// 				>
// 					{error || success}
// 				</div>
// 			)}
// 		</>
// 	);
// };

export const Input = classed("input", styles.input);
export const Label = classed("label", styles.label);

export const NativeSelect = classed("select", styles.input, "nativeSelect");

type TextFieldProps<T extends "input" | "select"> = ComponentProps<T> & {
	label?: React.ReactNode;
	subText?: React.ReactNode;
	error?: string | React.JSX.Element | boolean;
	success?: boolean;
	as?: T;
	classNames?: {
		root?: string;
		input?: string;
		label?: string;
	};
};

export const TextFieldBase = classed("div", styles.textField);

export const TextField = <Type extends "input" | "select" = "input">({
	label,
	as,
	classNames,
	className,
	subText,
	error,
	success,
	...props
}: TextFieldProps<Type>) => {
	const Comp = as === "select" ? NativeSelect : Input;

	return (
		<TextFieldBase className={clsx(classNames?.root, className)}>
			<Label className={classNames?.label}>
				{label && <span>{label}</span>}
				<Comp
					{...(props as {})}
					className={clsx(
						classNames?.input,
						error && styles.error,
						success && styles.success,
					)}
				/>
			</Label>
			{(subText || error) && (
				<span
					className={clsx(
						styles.text,
						error && styles.error,
						success && styles.success,
					)}
				>
					{error || subText}
				</span>
			)}
		</TextFieldBase>
	);
};
